import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=5ed0b81e&"
import script from "./NoAccess.vue?vue&type=script&lang=ts&"
export * from "./NoAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports